// @ts-nocheck

import { useHistory } from 'react-router';
import {
  processListing,
  setMarkerParams,
  processTailoredRegionMarkers,
  processOTAListings,
  processBookingData,
  makeLowerCase,
  isEmpty,
  calculateRevenuePotentialRange,
  getBoundedListings,
  getBoundedOTAListings,
  getFilteredListings,
  getVisibleListings,
  getVisibleOTAListings,
  convertBoundsArrayToObj,
  isLeapYear,
  fetchMonthlyHistoricalData,
  processMonthlyHistoricalData,
  brightConsole,
  parseMessageHistoricalData,
  calculateDashboardFilters,
} from 'src/utils/functions';
import {
  GET_GRAPH_LOAD_END,
  GET_GRAPH_LOAD_START,
  GET_SEARCH_LOAD_END,
  GET_SEARCH_LOAD_START,
  GET_MARKERS_LOAD_START,
  GET_MARKERS_LOAD_END,
  GET_OTA_MARKERS_LOAD_START,
  GET_OTA_MARKERS_LOAD_END,
  GET_MULTIPLE_MARKERS_CALL_LOAD_START,
  GET_MULTIPLE_MARKERS_CALL_LOAD_END,
  GET_MULTIPLE_OTA_MARKERS_CALL_LOAD_START,
  GET_MULTIPLE_OTA_MARKERS_CALL_LOAD_END,
  GET_TAILORED_REGION_MARKERS_SUCCESS,
  GET_REVIEW_STREAM_LOAD_START,
  GET_REVIEW_STREAM_LOAD_END,
  GET_BOOKING_CHANGES_LOAD_START,
  GET_BOOKING_CHANGES_LOAD_END,
  GET_FILTERED_BOOKINGS_LOAD_START,
  GET_FILTERED_BOOKINGS_LOAD_END,
  SEARCH_CHANGE,
  SET_USER_INFO,
  GET_COMPSETS_LOAD_START,
  GET_COMPSETS_LOAD_END,
  GET_COMPSET_LOAD_START,
  GET_COMPSET_LOAD_END,
  GET_COMPSET_LISTING_IDS_LOAD_START,
  GET_COMPSET_LISTING_IDS_LOAD_END,
  SET_IS_USER_ALLOWED,
  GET_USER_AIRBNB_LISTINGS_LOAD_START,
  GET_USER_AIRBNB_LISTINGS_LOAD_END,
  GET_LISTING_PRICING_RECOMMENDATION_LOAD_START,
  GET_LISTING_PRICING_RECOMMENDATION_LOAD_END,
  SET_CURRENCY,
  SET_SEARCH_LIMIT_BOX_ALERT,
  GET_BOOKING_DATA_LOAD_START,
  GET_BOOKING_DATA_LOAD_END,
  GET_BOOKING_MULTIPLE_MARKERS_LOAD_START,
  GET_BOOKING_MULTIPLE_MARKERS_LOAD_END,
  GET_NEARBY_RECOMMENDED_MARKETS_LOAD_START,
  GET_NEARBY_RECOMMENDED_MARKETS_LOAD_END,
  SET_REV_POTENTIAL_RANGE_INVESTMENT,
  EMPTY_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN,
  SET_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN,
  SET_BOUNDS_MAP_INSIGHTS,
  SET_FILTERS_INSIGHTS,
  SET_FILTER_INSIGHTS_ACTIVE,
  SET_USER_COUNTRY_CODE,
  SET_INDIVIDUAL_REV_POTENTIAL_RANGE,
  SET_HISTORICAL_DATA,
  SET_ANNUAL_REVENUE_DATA_FOR_CALCULATOR,
  GET_CACHED_SEARCH_MARKETS,
  SET_AIRBTICS_PRO_BANNER_VISIBLE,
  SET_TOP_BANNER_OPEN,
  GET_LOCKED_MARKET_INSIGHT_LOADING,
  SET_MAX_SAMPLE_REV_POTENTIAL_PROPERTY_SIZE,
  SET_SEARCHED_MARKET_ESTIMATOR,
  SET_MARKET_CACHED_DATA,
  GET_MARKET_CACHED_DATA,
  SET_MARKET_DASHBOARD_FILTER_DATA,
} from 'src/store/Dashboard/types';
import {
  Listing,
  Search,
  Graph,
  ReviewStream,
  BookingChanges,
  RateAndAvailChanges,
  TailoredRegionMarkers,
  NearbyRecommendedMarket,
  CachedSearchedMarketsType,
  FilteredListingsDashboardDataType,
} from '../../interfaces/idashboard';
import { User } from '../../interfaces/iuser';
import { AppDispatch } from '../../core/StoreProvier/StoreProvider';
import mixpanel from 'mixpanel-browser';
import { CompsetFilterVal } from 'src/interfaces/iproptypes';
import {
  OVERVIEW_DASHBOARD_FILTER_DEMO_DATA,
  daysInMonth,
  fuseSearchOptions,
  sampleMarket,
} from 'src/const';
// import demoGranularDataDaily from 'src/demoGranularDataDaily';
import { callApi } from 'src/core/callApi';
import pako from 'pako';
import Fuse from 'fuse.js';
import axios from 'axios';
mixpanel.init('0c9d3451de8e0a1a2f21ec23b05c2063');

const getMarkersLoadStart = () => ({
  type: GET_MARKERS_LOAD_START,
});

export const setListings = (payload: Listings) => ({
  type: GET_MARKERS_LOAD_END,
  payload,
});

const setlockedMarketInsightLoading = (payload: any) => ({
  type: GET_LOCKED_MARKET_INSIGHT_LOADING,
  payload,
});

const getOTAMarkersLoadStart = () => ({
  type: GET_OTA_MARKERS_LOAD_START,
});

export const setOTAListings = (payload: any) => ({
  type: GET_OTA_MARKERS_LOAD_END,
  payload,
});

const getMultipleMarkersCallLoadStart = () => ({
  type: GET_MULTIPLE_MARKERS_CALL_LOAD_START,
});

const getMultipleMarkersCallLoadEnd = () => ({
  type: GET_MULTIPLE_MARKERS_CALL_LOAD_END,
});

const getMultipleOTAMarkersCallLoadStart = () => ({
  type: GET_MULTIPLE_OTA_MARKERS_CALL_LOAD_START,
});

const getMultipleOTAMarkersCallLoadEnd = () => ({
  type: GET_MULTIPLE_OTA_MARKERS_CALL_LOAD_END,
});

const getTailoredRegionMarkersSuccess = (payload: TailoredRegionMarkers[]) => ({
  type: GET_TAILORED_REGION_MARKERS_SUCCESS,
  payload,
});

const getGraphLoadStart = () => ({
  type: GET_GRAPH_LOAD_START,
});

const getGraphLoadEnd = (payload: Graph) => ({
  type: GET_GRAPH_LOAD_END,
  payload,
});

export const getSearchLoadStart = () => ({
  type: GET_SEARCH_LOAD_START,
});

export const getSearchLoadEnd = () => ({
  type: GET_SEARCH_LOAD_END,
});

const getReviewStreamLoadStart = () => ({
  type: GET_REVIEW_STREAM_LOAD_START,
});

const getReviewStreamLoadEnd = (payload: ReviewStream) => ({
  type: GET_REVIEW_STREAM_LOAD_END,
  payload,
});

const getBookingChangesLoadStart = () => ({
  type: GET_BOOKING_CHANGES_LOAD_START,
});

const getBookingChangesLoadEnd = (payload: BookingChanges) => ({
  type: GET_BOOKING_CHANGES_LOAD_END,
  payload,
});

const getMultipleBookingDataLoadStart = () => ({
  type: GET_BOOKING_MULTIPLE_MARKERS_LOAD_START,
});

const getMultipleBookingDataLoadEnd = () => ({
  type: GET_BOOKING_MULTIPLE_MARKERS_LOAD_END,
});

const getFilteredBookingsLoadStart = () => ({
  type: GET_FILTERED_BOOKINGS_LOAD_START,
});

export const setFilteredBookings = (payload: RateAndAvailChanges[]) => ({
  type: GET_FILTERED_BOOKINGS_LOAD_END,
  payload,
});

export const setEstimatorSearchedMarket = payload => ({
  type: SET_SEARCHED_MARKET_ESTIMATOR,
  payload,
});

const setUserInfo = (payload: User) => ({
  type: SET_USER_INFO,
  payload,
});

// const getCompsetsLoadStart = () => ({
//   type: GET_COMPSETS_LOAD_START,
// });

// const getCompsetsLoadEnd = (payload: Compset[]) => ({
//   type: GET_COMPSETS_LOAD_END,
//   payload,
// });

// const getCompsetLoadStart = () => ({
//   type: GET_COMPSET_LOAD_START,
// });

// const setCompset = (payload: Compset) => ({
//   type: GET_COMPSET_LOAD_END,
//   payload,
// });

export const getCompsetListingIdsLoadStart = () => ({
  type: GET_COMPSET_LISTING_IDS_LOAD_START,
});

export const setAnnualRevenueDataForCalculator = (payload: number) => ({
  type: SET_ANNUAL_REVENUE_DATA_FOR_CALCULATOR,
  payload,
});

export const setMaxSampleRevenuePotentialPropertySize = (payload: number) => ({
  type: SET_MAX_SAMPLE_REV_POTENTIAL_PROPERTY_SIZE,
  payload,
});

export const setCompsetListingIds = (payload: number[]) => ({
  type: GET_COMPSET_LISTING_IDS_LOAD_END,
  payload,
});

export const setUserCountryCode = (payload: string) => ({
  type: SET_USER_COUNTRY_CODE,
  payload,
});

export const setIsUserAllowed = payload => ({
  type: SET_IS_USER_ALLOWED,
  payload,
});

export const getBookingDataLoadStart = () => ({
  type: GET_BOOKING_DATA_LOAD_START,
});

export const setBookingData = payload => ({
  type: GET_BOOKING_DATA_LOAD_END,
  payload,
});

const resetMarket = metaData => (dispatch: AppDispatch, getState) => {
  const {
    dashboard: { isUserAllowed },
  } = getState();
  dispatch(getMarkers(false, 0, metaData));
  dispatch(getOTAMarkers());
  dispatch(getBookingData());
};

export const getNearbyRecommendedMarketsLoadingStart = () => ({
  type: GET_NEARBY_RECOMMENDED_MARKETS_LOAD_START,
});

export const getNearbyRecommendedMarketsLoadingEnd = payload => ({
  type: GET_NEARBY_RECOMMENDED_MARKETS_LOAD_END,
  payload,
});

export const setRevenuePotentialRange = (payload: { [key: number]: 'visible' | 'hidden' }) => ({
  type: SET_REV_POTENTIAL_RANGE_INVESTMENT,
  payload,
});

export const setIndividualRevenuePotentialRange = (payload: {
  [key: number]: 'visible' | 'hidden';
}) => ({
  type: SET_INDIVIDUAL_REV_POTENTIAL_RANGE,
  payload,
});

export const setBoundsMapInsights = (payload: number[]) => ({
  type: SET_BOUNDS_MAP_INSIGHTS,
  payload: payload,
});

export const setFiltersInsights = payload => ({
  type: SET_FILTERS_INSIGHTS,
  payload: payload,
});

export const setFilterInsightsActive = payload => ({
  type: SET_FILTER_INSIGHTS_ACTIVE,
  payload: payload,
});

export const getDistrictInfo = (district: string, city: string, country: string) => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  dispatch(getSearchLoadStart());
  const {
    dashboard: { search },
  } = getState();
  // const url = 'https://68gjq7no20.execute-api.us-east-2.amazonaws.com/default/getDistrictInfo';
  const url = 'https://ney85gkj5f.execute-api.us-east-2.amazonaws.com/default/getDistrictInfoTest';
  const config = {
    district: district,
    city: city,
    country: country,
  };

  try {
    const response = await api(url, { queryParams: config }, true);
    const districtObj = response.message;

    const country = districtObj['country'];
    const city = districtObj['city'];
    const district = districtObj['name'];

    const newSearchObj = {
      name: district,
      lat: districtObj['lat'],
      lng: districtObj['lng'],
      polygon: districtObj['polygon'],
      multiPolygon: districtObj['multiPolygon'],
      city: city,
      country: country,
      countryCode: districtObj['countryCode'],
      bounds: convertBoundsArrayToObj(districtObj['bounds']),
      recommendPageURLs: districtObj['recommendPageURLs'],
      isTailoredRegion: false,
      currency: districtObj['currency'],
      isVerified: districtObj['isVerified'],
      marketID: districtObj['marketID'],
      cachedFilesCount: districtObj['cachedFilesCount'],
      annualAppreciation: districtObj['annual_appreciation'],
      property_price: districtObj['property_price'],
    };

    const metaData: any = {
      name: district,
      countryCode: districtObj['countryCode'],
      city: districtObj['city'],
    };

    dispatch(fetchCachedMarketData(newSearchObj.name, newSearchObj.city, newSearchObj.countryCode));

    dispatch(searchChange({ ...search, data: { ...search.data, ...newSearchObj } }));
    dispatch(getSearchLoadEnd());
    dispatch(resetMarket(metaData));
    dispatch(getGraphData());
  } catch (err) {
    console.log('Unhandled error while calling getDistrictInfo ', err);
    dispatch(getSearchLoadEnd());
  }
};

// calls getMarkers API in loop for max of 100 times

export const getMarkers = (unlockRegion = false, creditsToBeDeducted = 0, metaData) => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  dispatch(getMarkersLoadStart());
  dispatch(getMultipleMarkersCallLoadStart());

  const {
    dashboard: { search },
  } = getState();

  if (search.data.name.toLowerCase() === sampleMarket) {
    dispatch(setIsUserAllowed(true));
    const url = 'https://default-market-data-cache.s3.us-east-2.amazonaws.com/getMarkers.json';
    const response = await api(url, {}, false);
    const listings = processListing(response.message, response.dates, response.historical_dates);
    dispatch(setRevenuePotentialRange(calculateRevenuePotentialRange(listings)));
    dispatch(setListings(listings));
    dispatch(getMultipleMarkersCallLoadEnd());
    dispatch(setlockedMarketInsightLoading(false));
    dispatch(setMarketDashboardFilter(calculateDashboardFilters(listings)));
    return;
  }

  const url = 'https://8a8j1g1opk.execute-api.us-east-2.amazonaws.com/default/getMarkers';
  // const url = 'https://b7oek764te.execute-api.us-east-2.amazonaws.com/default/getMarkersTest';
  let markerParam = { ...search.data };
  delete markerParam.polygon;
  delete markerParam.multiPolygon;
  delete markerParam.lat;
  delete markerParam.lng;
  delete markerParam.bounds;
  delete markerParam.country;

  if (unlockRegion) {
    markerParam = { ...markerParam, unlockRegion: true, creditsToBeDeducted };
  }

  let listings = {};
  let isUserAllowed = false;
  let isUserAllowedUpdated = false;
  let callsMade = 0;
  const MAX_CALL_RESPONSE_LENGTH = 1000;

  while (callsMade < 200) {
    try {
      const {
        dashboard: { boundsMapInsights, filtersInsights, filterInsightsActive },
      } = getState();

      const offset = callsMade * MAX_CALL_RESPONSE_LENGTH;
      markerParam = { ...markerParam, offset: offset };

      let response = await api(url, { queryParams: markerParam }, true, true);

      let reload = response.reload;
      if (reload) {
        window.location.reload();
        return;
      }

      const listingsFromBE = processListing(response.message, response.isUserAllowed);

      if (!isUserAllowedUpdated && response.isUserAllowed !== undefined) {
        isUserAllowed = response.isUserAllowed;
        dispatch(setIsUserAllowed(isUserAllowed));
        console.log('IS USER ALLOWED [ACTION] ', isUserAllowed);
        isUserAllowedUpdated = true;
      }

      listings = { ...listings, ...listingsFromBE };

      if (response.message.length > 0) {
        dispatch(setRevenuePotentialRange(calculateRevenuePotentialRange(listings)));
      }

      if (Object.keys(listingsFromBE).length > 0) {
        dispatch(
          setMarketDashboardFilter(calculateDashboardFilters(listings, response.isUserAllowed))
        );
        const boundedListings: string[] = getBoundedListings(listings, boundsMapInsights);
        const [filteredListings, _] = getFilteredListings(
          listings,
          {},
          filtersInsights,
          filterInsightsActive
        ) as [string[], string[]];
        const visibleListings = new Set(getVisibleListings(boundedListings, filteredListings));
        let updatedListings = {};
        Object.keys(listings).forEach(listingID => {
          updatedListings[listingID] = {
            ...listings[listingID],
            visible: visibleListings.has(listingID) ? true : false,
          };
        });
        dispatch(setListings(updatedListings));
      }
      dispatch(getUserInfo());
      dispatch(setlockedMarketInsightLoading(false));

      if (response.message.length < MAX_CALL_RESPONSE_LENGTH) {
        // dispatch(getMultipleMarkersCallLoadEnd());
        mixpanel.track('visitMain', {
          region: markerParam.name,
        });
        break;
      }

      callsMade += 1;
    } catch (e) {
      console.log('error. Ignore and run again ', e);
    }
  }

  dispatch(getMultipleMarkersCallLoadEnd());
};

export const getHighLowRevPotentialInvestment = () => (dispatch: AppDispatch, getState, api) => {
  const {
    dashboard: { listings },
  } = getState();

  if (listings.data && listings.data.length !== 0) {
    const revPotentialRange: number[] = calculateRevenuePotentialRange(listings.data);
    dispatch(setRevenuePotentialRange(revPotentialRange));
  }
};

export const getOTAMarkers = () => async (dispatch: AppDispatch, getState, api) => {
  // return;
  dispatch(getOTAMarkersLoadStart());
  dispatch(getMultipleOTAMarkersCallLoadStart());

  const {
    dashboard: { search },
  } = getState();

  if (search.data.name.toLowerCase() === sampleMarket) {
    const url = 'https://default-market-data-cache.s3.us-east-2.amazonaws.com/getOTAMarkers.json';
    const response = await api(url, {}, false);
    const otaListings = processOTAListings(response.message);
    dispatch(setOTAListings(otaListings));
    dispatch(getMultipleOTAMarkersCallLoadEnd());
    return;
  }

  let markerParam = { ...search.data };
  delete markerParam.polygon;
  delete markerParam.multiPolygon;
  delete markerParam.lat;
  delete markerParam.lng;
  delete markerParam.bounds;
  delete markerParam.country;

  const url = `https://pgvfho57od.execute-api.us-east-2.amazonaws.com/default/getOTAMarkers`;
  let otaListings = {};

  try {
    const {
      dashboard: { boundsMapInsights, filtersInsights, filterInsightsActive },
    } = getState();

    let response = await api(url, { queryParams: markerParam }, true, true);
    const otaListingsFromBE = processOTAListings(response.message);
    otaListings = { ...otaListings, ...otaListingsFromBE };
    const tempBoundedOTAListings = getBoundedOTAListings(otaListings, boundsMapInsights);
    const [_, filteredOTAListings] = getFilteredListings(
      {},
      otaListings,
      filtersInsights,
      filterInsightsActive
    ) as [string[], string[]];
    const visibleOTAListings = new Set(
      getVisibleOTAListings(tempBoundedOTAListings, filteredOTAListings)
    );
    let updatedOTAListings = {};
    Object.keys(otaListings).forEach(listingID => {
      updatedOTAListings[listingID] = {
        ...otaListings[listingID],
        visible: visibleOTAListings.has(listingID) ? true : false,
      };
    });
    dispatch(setOTAListings(updatedOTAListings));
  } catch (err) {
    console.log('error while making a request to booking details', err);
  }

  dispatch(getMultipleOTAMarkersCallLoadEnd());
};

export const getBookingData = () => async (dispatch: AppDispatch, getState, api) => {
  return;

  dispatch(getBookingDataLoadStart());
  dispatch(getMultipleBookingDataLoadStart());

  const {
    dashboard: {
      search: {
        data: { name, city, countryCode },
      },
    },
  } = getState();

  if (name.toLowerCase() === sampleMarket) {
    const url = 'https://default-market-data-cache.s3.us-east-2.amazonaws.com/getBookingData.json';
    const response = await api(url, {}, false);
    const bookingData = { ...response.bookings };
    dispatch(setBookingData(bookingData));
    dispatch(getMultipleBookingDataLoadEnd());
    return;
  }

  const url = 'https://3py91q55hg.execute-api.us-east-2.amazonaws.com/default/getBookingData';

  let offset = null;
  let bookingData: any = {};

  let marketParams = { name, city, countryCode };

  for (let i = 0; i < 15; i++) {
    try {
      if (offset) {
        marketParams = { ...marketParams, offset };
      }
      let response = await api(url, { queryParams: marketParams }, true, true);
      offset = response.message.lastListingID;

      const {
        dashboard: { listings },
      } = getState();

      if (response.message) {
        let reload = response.message.reload;
        if (reload) {
          window.location.reload();
          return;
        }

        if (response.message.bookings && !isEmpty(response.message.bookings)) {
          bookingData = { ...bookingData, ...response.message.bookings };
          dispatch(setBookingData(bookingData));
        }
      }
      if (
        response.message.callAgain == false ||
        (response.message.error && response.message.error === 'Unauthorized request')
      ) {
        break;
      }
    } catch (err) {
      console.log('error while making a request to booking details', err);
    }
  }

  dispatch(getMultipleBookingDataLoadEnd());
};

export const getTailoredRegionMarkers = bounds => async (dispatch: AppDispatch, getState, api) => {
  const url =
    'https://rd9s3wn350.execute-api.us-east-2.amazonaws.com/default/getMarkersTailorRegion';
  let markerParam = {};
  setMarkerParams(markerParam, bounds);

  const response = await api(url, { queryParams: markerParam }, false);
  if (typeof response.message === 'string') {
    return;
  }

  const tailoredRegionMarkers = processTailoredRegionMarkers(response.message);
  dispatch(getTailoredRegionMarkersSuccess(tailoredRegionMarkers));
  mixpanel.track('visitTailoredRegion', {
    country: markerParam.country,
  });
};

export const getGraphData = () => async (dispatch: AppDispatch, getState, api) => {
  //const url = 'https://1gd0fs8w2c.execute-api.us-east-2.amazonaws.com/default/getGraphData';
  const url = 'https://eo03ieyn04.execute-api.us-east-2.amazonaws.com/default/getGuestOrigin';
  dispatch(getGraphLoadStart());
  let {
    dashboard: { search },
  } = getState();

  let markerParam = { ...search.data };
  delete markerParam.polygon;
  delete markerParam.multiPolygon;
  delete markerParam.bounds;
  delete markerParam.lat;
  delete markerParam.lng;
  delete markerParam.country;

  const response = await api(url, { queryParams: markerParam }, true);
  if (response.message !== 'Failed to fetch') {
    dispatch(getGraphLoadEnd(response.message));
  }
};

export const getReviewStream = () => async (dispatch: AppDispatch, getState, api) => {
  const url = 'https://x5cv061l6c.execute-api.us-east-2.amazonaws.com/default/getReviewStream';
  dispatch(getReviewStreamLoadStart());
  let {
    dashboard: { search },
  } = getState();

  let markerParam = { ...search.data };
  delete markerParam.polygon;
  delete markerParam.multiPolygon;
  delete markerParam.country;
  delete markerParam.lat;
  delete markerParam.lng;
  delete markerParam.zoom;
  delete markerParam.bounds;
  delete markerParam.isTailoredRegion;

  let auth = true;
  if (makeLowerCase(search.data.name) == sampleMarket) {
    auth = false;
  }
  const response = await api(url, { queryParams: markerParam }, auth);
  dispatch(getReviewStreamLoadEnd(response.message));
};

export const getUserInfo = () => async (dispatch: AppDispatch, __, api, _) => {
  const url = 'https://w1ec9zcvbk.execute-api.us-east-2.amazonaws.com/default/getUserInfo';
  const response = await api(url, {}, true);

  if (response && response.message) {
    let user: User = response.message;
    console.log('user', user);
    if (user == 'Failed to fetch' || user == 'Invalid Auth Token') {
      return;
    }
    dispatch(setUserInfo(user));
    mixpanel.identify(user.email);
    if (user.regions) {
      mixpanel.people.set({
        $name: user.userName,
        $email: user.email,
        $role: user.role,
        $plan: 'paid',
      });
    }
    mixpanel.people.set({
      $name: user.userName,
      $email: user.email,
      $role: user.role,
      $plan: 'unpaid',
    });
    if (user && user.email && user.email.includes('@airbtics.com')) {
      mixpanel.opt_out_tracking();
    }
  }
};

export const searchChange = (payload: Search) => ({
  type: SEARCH_CHANGE,
  payload,
});

// TODO: Change this to fetch coordinates of city
export const getSearch = () => async (dispatch: AppDispatch) => {
  dispatch(getSearchLoadStart());

  dispatch(getSearchLoadEnd());
};

// export const getBookingChanges = (page: Number, compsetID: string) => async (
//   dispatch: AppDispatch,
//   getState,
//   api
// ) => {
//   //const httpURL = 'https://pxr62jesh1.execute-api.us-east-2.amazonaws.com/default/getBookingChanges';
//   const restURL =
//     'https://g5lt3ceycf.execute-api.us-east-2.amazonaws.com/default/getBookingChanges';
//   const testURL =
//     'https://sjje1neo4l.execute-api.us-east-2.amazonaws.com/default/getBookingChangesTest';
//   dispatch(getBookingChangesLoadStart());
//   dispatch(getFilteredBookingsLoadStart());
//   let {
//     dashboard: { search, filteredBookings },
//   } = getState();

//   let markerParam = { ...search.data };
//   delete markerParam.polygon;
//   delete markerParam.multiPolygon;
//   delete markerParam.country;
//   delete markerParam.lat;
//   delete markerParam.lng;
//   delete markerParam.zoom;
//   delete markerParam.bounds;
//   delete markerParam.isTailoredRegion;
//   delete markerParam.name;
//   delete markerParam.city;
//   delete markerParam.countryCode;

//   try {
//     markerParam['page'] = page;
//     markerParam['compset_id'] = compsetID;

//     const response = await api(restURL, { queryParams: markerParam }, false, true);

//     let bookingChangesFromBE = [];

//     // Concating rows

//     // if (page > 1 && typeof response.message.booking_changes.rate_and_avail_changes != 'string') {
//     //   bookingChangesFromBE = filteredBookings.data.concat(
//     //     response.message.booking_changes.rate_and_avail_changes
//     //   );
//     // } else {
//     //   bookingChangesFromBE = response.message.booking_changes.rate_and_avail_changes;
//     // }

//     if (response.message.booking_changes.rate_and_avail_changes.length > 0)
//       bookingChangesFromBE = response.message.booking_changes.rate_and_avail_changes;
//     else bookingChangesFromBE = [];
//     // console.log("booking changes from BE ", bookingChangesFromBE)
//     dispatch(getBookingChangesLoadEnd(response.message.booking_changes));
//     dispatch(setFilteredBookings(bookingChangesFromBE));
//     mixpanel.track('visitPacing', {
//       region: markerParam.name,
//     });
//   } catch (e) {
//     console.log('error. ', e);
//   }
// };

// export const compsetCRUD = (
//   operation: string,
//   compsetName: string,
//   id: string,
//   listingIDs: number[] | string[],
//   filters: CompsetFilterVal[]
// ) => async (dispatch: AppDispatch, getState, api) => {
//   dispatch(getCompsetsLoadStart());
//   const restURL = 'https://wp3g0m94a4.execute-api.us-east-2.amazonaws.com/default/compsetCRUD';
//   const httpURL = 'https://jjosc8ay07.execute-api.us-east-2.amazonaws.com/default/compsetCRUD';
//   let {
//     dashboard: { search, filteredBookings },
//   } = getState();

//   let markerParam = { ...search.data };
//   delete markerParam.polygon;
//   delete markerParam.multiPolygon;
//   delete markerParam.country;
//   delete markerParam.lat;
//   delete markerParam.lng;
//   delete markerParam.zoom;
//   delete markerParam.bounds;
//   delete markerParam.isTailoredRegion;

//   markerParam.operation = operation;

//   if (operation === 'CREATE' && compsetName && filters) {
//     markerParam.compsetName = compsetName;
//     // filters
//     let columns: string[] = [];
//     let operators: string[] = [];
//     let values: string[] = [];
//     filters.map((filter: CompsetFilterVal, index: number) => {
//       columns.push(filter.column);
//       operators.push(filter.operator);
//       values.push(filter.value);
//     });
//     markerParam['filters_count'] = columns.length;
//     columns.map((column, index) => {
//       const operator = operators[index];
//       const value = values[index];
//       markerParam[`filter_${index}`] = `${column} - ${operator} - ${value}`;
//     });
//   }

//   if (operation === 'UPDATE' && id && listingIDs) {
//     markerParam.id = id;
//     let listingIDs_string = '';
//     listingIDs.map((listingID, index) => {
//       listingIDs_string += `${listingID}, `;
//     });
//     listingIDs_string = listingIDs_string.slice(0, -2);
//     markerParam.listingIDs = listingIDs_string;
//   }

//   if (operation === 'DELETE_COMP_LISTINGS' && id && listingIDs) {
//     markerParam.id = id;
//     let listingIDs_string = '';
//     listingIDs.map((listingID, index) => {
//       listingIDs_string += `${listingID},`;
//     });
//     listingIDs_string = listingIDs_string.slice(0, -1);
//     markerParam.deletedCompListingIDs = listingIDs_string;
//   }

//   if (operation === 'RESET_DELETED_COMP_LISTINGS' && id) {
//     markerParam.id = id;
//   }

//   if ((operation === 'DELETE' || operation === 'READ_ID') && id) {
//     markerParam.id = id;
//   }

//   let compsets: Commpset[] = [];
//   try {
//     const response = await api(httpURL, { queryParams: markerParam }, true);

//     if (operation === 'CREATE') {
//       dispatch(getCompsetLoadStart());
//       dispatch(getCompsetListingIdsLoadStart());
//       const compset = response.message.compset;
//       const listingIDs = response.message.compset.listingIDs;
//       dispatch(setCompsetListingIds(listingIDs));
//       if (listingIDs.length > 0) {
//         window.history.pushState({}, '', `/compset/${response.message.compset.id}`);
//         dispatch(setCompset(compset));
//         dispatch(getBookingChanges(1, compset.id));
//         dispatch(compsetCRUD('READ'));
//       }
//     }

//     if (operation === 'UPDATE') {
//       dispatch(getCompsetListingIdsLoadStart());
//       const listingIDs = response.message.updated_listingIDs;
//       dispatch(setCompsetListingIds(listingIDs));
//       if (listingIDs.length > 0) {
//         dispatch(getBookingChanges(1, id));
//         dispatch(compsetCRUD('READ'));
//       }
//     }

//     if (operation === 'READ') {
//       compsets = response.message.compsets;
//       dispatch(getCompsetsLoadEnd(compsets));
//     }

//     if (operation === 'READ_ID') {
//       dispatch(compsetCRUD('READ'));
//       dispatch(getCompsetLoadStart());
//       dispatch(getCompsetListingIdsLoadStart());
//       const compset = response.message.compset;
//       dispatch(setCompset(compset));
//       dispatch(setCompsetListingIds(compset.listingIDs));
//       dispatch(getBookingChanges(1, compset.id));
//     }

//     if (operation === 'DELETE') {
//       dispatch(getBookingChangesLoadStart());
//       dispatch(compsetCRUD('READ'));
//     }

//     if (operation === 'DELETE_COMP_LISTINGS' || operation === 'RESET_DELETED_COMP_LISTINGS') {
//       const message = response.message;
//       if (message === 'unauthorized_request') {
//         window.alert(
//           'Failed to delete compset listing. Please try again. If the problem persists, please contact support.'
//         );
//       }
//     }

//     if (operation === 'RESET_DELETED_COMP_LISTINGS') {
//       const message = response.message;
//       if (message === 'unauthorized_request') {
//         window.alert(
//           'Failed to reset compset. Please try again. If the problem persists, please contact support.'
//         );
//       }
//     }
//   } catch (e) {
//     console.log('error. ', e);
//   }
// };

export const setCurrency = (payload: str) => ({
  type: SET_CURRENCY,
  payload,
});

export const getNearbyRecommendedMarkets = (
  searchedMarkets: any[],
  reqMarketsCount: number,
  lastPromise: React.MutableRefObject<any>
) => async (dispatch: AppDispatch, getState, api) => {
  dispatch(getNearbyRecommendedMarketsLoadingStart());
  try {
    const url =
      'https://pjm7yob50d.execute-api.us-east-2.amazonaws.com/default/getNearbyRecommendedMarkets';
    const config = {
      queryParams: {
        inputMarkets: JSON.stringify(searchedMarkets),
        number_of_return_markets: reqMarketsCount,
      },
    };

    const currentPromise = api(url, config, true).then(response => {
      return response;
    });
    lastPromise.current = currentPromise;

    currentPromise.then(
      response => {
        if (currentPromise === lastPromise.current) {
          dispatch(getNearbyRecommendedMarketsLoadingEnd(response));
        }
      },
      e => {
        if (currentPromise === lastPromise.current) {
          console.warn('fetch failure', e);
        }
      }
    );
  } catch (err) {
    console.error('Failed to fetch nearby markets!');
    dispatch(getNearbyRecommendedMarketsLoadingEnd([]));
  }
};

// bright pricing
const getUserAirbnbListingsLoadStart = () => ({
  type: GET_USER_AIRBNB_LISTINGS_LOAD_START,
});

const getUserAirbnbListingsLoadEnd = payload => ({
  type: GET_USER_AIRBNB_LISTINGS_LOAD_END,
  payload,
});

const getListingPricingRecommendationLoadStart = () => ({
  type: GET_LISTING_PRICING_RECOMMENDATION_LOAD_START,
});

const getListingPricingRecommendationLoadEnd = payload => ({
  type: GET_LISTING_PRICING_RECOMMENDATION_LOAD_END,
  payload,
});

export const getUserAirbnbListings = () => async (dispatch: AppDispatch, getState, api) => {
  dispatch(getUserAirbnbListingsLoadStart());
  const url =
    'https://hilpzzpeo4.execute-api.us-east-2.amazonaws.com/default/getUserAirbnbListings';
  let userAirbnbListings = [];
  try {
    const response = await api(url, {}, true);
    userAirbnbListings = response.message;
    dispatch(getUserAirbnbListingsLoadEnd(userAirbnbListings));
  } catch (e) {
    console.log('error: ', e);
  }
};

export const getListingPricingRecommendation = (listingID: string, pushPricing: boolean) => async (
  dispatch: AppDispatch,
  getState,
  api
) => {
  const url =
    'https://5v07hdzm7g.execute-api.us-east-2.amazonaws.com/default/getListingPricingRecommendation';
  try {
    if (pushPricing) {
      const response = await api(
        url,
        { queryParams: { listingID: listingID, pushPricing: true } },
        true
      );
    } else {
      dispatch(getListingPricingRecommendationLoadStart());
      const response = await api(url, { queryParams: { listingID: listingID } }, true);
      dispatch(getListingPricingRecommendationLoadEnd(response));
    }
  } catch (e) {
    console.log('error: ', e);
  }
};

// export const fetchCompset = (listingID: number) => async (dispatch: AppDispatch, getState, api) => {
//   dispatch(getCompsetsLoadStart());
//   const restURL = 'https://wp3g0m94a4.execute-api.us-east-2.amazonaws.com/default/compsetCRUD';
//   const httpURL = 'https://jjosc8ay07.execute-api.us-east-2.amazonaws.com/default/compsetCRUD';

//   try {
//     const response = await api(
//       httpURL,
//       { queryParams: { operation: 'CREATE', listingID: listingID } },
//       true
//     );
//     dispatch(getCompsetLoadStart());
//     dispatch(getCompsetListingIdsLoadStart());
//     const compset = response.message.compset;
//     const listingIDs = response.message.compset.listingIDs;
//     dispatch(setCompsetListingIds(listingIDs));
//     if (listingIDs.length > 0) {
//       dispatch(setCompset(compset));
//       dispatch(getBookingChanges(1, compset.id));
//     }
//   } catch (e) {
//     console.log('error. ', e);
//   }
// };

export const setSearchLimitAlertBox = (payload: boolean) => ({
  type: SET_SEARCH_LIMIT_BOX_ALERT,
  payload,
});

const setGoogleAutocompleteSessionToken = payload => ({
  type: SET_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN,
  payload: payload,
});

export const getGoogleAutocompleteSessionToken = loader => async (dispatch: AppDispatch) => {
  const google = !loader ? (window as any).google : await loader.load();

  const sessionToken = new google.maps.places.AutocompleteSessionToken();
  // console.log('==', sessionToken);
  dispatch(setGoogleAutocompleteSessionToken(sessionToken));
  return sessionToken;
};

export const clearGoogleAutocompleteSessionToken = () => ({
  type: EMPTY_GOOGLE_AUTOCOMPLETE_SESSION_TOKEN,
});

export const setHistoricalData = payload => ({
  type: SET_HISTORICAL_DATA,
  payload: payload,
});

export const fetchDemoHistoryFromS3 = async () => {
  const url = 'https://airbtics-resource.s3.us-east-2.amazonaws.com/demoGranularDataDaily.json';
  try {
    const result = await fetchMonthlyHistoricalData(url, false);
    return result;
  } catch (err) {
    console.log('Error while calling demo granularity data: ', err);
    return null;
  }
};

export const setCachedSearchMarkets = payload => ({
  type: GET_CACHED_SEARCH_MARKETS,
  payload,
});

// FuseOptions, FuseResultWithMatches

export const getCachedSearchMarkets = () => async (dispatch: AppDispatch) => {
  const marketBuffer = await axios.get(
    'https://airbtics-resource.s3.us-east-2.amazonaws.com/public_markets_compressed.json.gz',
    {
      responseType: 'arraybuffer',
      decompress: true,
    }
  );
  const markets: CachedSearchedMarketsType[] = await JSON.parse(
    pako.inflate(marketBuffer.data, { to: 'string' })
  );
  const fuse: Fuse<CachedSearchedMarketsType> = new Fuse(markets, fuseSearchOptions);

  dispatch(setCachedSearchMarkets({ fuse, markets }));
};

export const setTopBannerOpen = (payload: boolean) => ({
  type: SET_TOP_BANNER_OPEN,
  payload,
});

export const fetchCachedMarketData = (
  name: string,
  city: string | 0,
  countryCode: string
) => async (dispatch: AppDispatch, getState, api) => {
  // const URL = 'https://6co0gb5kb6.execute-api.us-east-2.amazonaws.com/default/getMarketDataCache';
  const URL =
    'https://43kxfqfm00.execute-api.us-east-2.amazonaws.com/default/getMarketDataCacheTest';

  const TIME_DURATION_TO_CALL_AGAIN = 5; // in seconds

  try {
    dispatch(setCachedMarketDataLoading());

    const { message } = await api(URL, { queryParams: { name, city, countryCode } }, true);
    brightConsole().log(name, city, countryCode);

    if (!message || typeof message == 'string' || message.is_sample) {
      if (message && message.is_sample) {
        const parsedMessage = parseMessageHistoricalData(message);
        dispatch(setCachedMarketData(parsedMessage));
      }
      setTimeout(() => {
        dispatch(fetchCachedMarketData(name, city, countryCode));
      }, TIME_DURATION_TO_CALL_AGAIN * 1000);
    } else {
      const parsedMessage = parseMessageHistoricalData(message);
      dispatch(setCachedMarketData(parsedMessage));
    }
  } catch (err) {
    brightConsole().error(err);
    setTimeout(() => {
      dispatch(fetchCachedMarketData(name, city, countryCode));
    }, TIME_DURATION_TO_CALL_AGAIN * 1000);
  }
};

export const setCachedMarketDataLoading = () => ({
  type: GET_MARKET_CACHED_DATA,
});

export const setCachedMarketData = (payload: any) => ({
  type: SET_MARKET_CACHED_DATA,
  payload: payload,
});

export const setMarketDashboardFilter = (payload: FilteredListingsDashboardDataType) => ({
  type: SET_MARKET_DASHBOARD_FILTER_DATA,
  payload,
});
